
import { all, call, fork, put, takeEvery, select } from 'redux-saga/effects';
import { LOGIN_USER, LOGOUT_USER, REGISTER_USER, FORGET_PASSWORD, SAVE_BANK_ATTRIBUTES, SAVE_BUSINESS_ATTRIBUTES, SEND_DOCUMENTS, UPDATE_USER, UPDATE_COMPANY_TAGS, CHANGE_PASSWORD, SAVE_MERCADO_PAGO_TOKEN, SAVE_PAG_SEGURO_CREDENTIALS, SAVE_GETNET_CREDENTIALS, CREATE_PIX_KEY } from './constants';
import {
    loginUserSuccess,
    loginUserError,
    registerUserSuccess,
    registerUserError,
    updateUserSuccess,
    updateUserError,
    forgetPasswordSuccess,
    forgetPasswordError,
    saveBusinessAttributesSuccess,
    saveBusinessAttributesError,
    sendDocumentsSuccess,
    sendDocumentsError,
    saveBankAttributesSuccess,
    saveBankAttributesError,
    updateUserFields,
    updateCompanyTagsSuccess,
    updateCompanyTagsError,
    changePasswordSucces,
    changePasswordError,
    saveMercadoPagoTokenSuccess,
    saveMercadoPagoTokenError,
    savePagSeguroCredentialsSuccess,
    savePagSeguroCredentialsError, saveGetnetCredentialsSuccess, saveGetnetCredentialsError, createPixKeySuccess, createPixKeyError
} from './actions';
import AuthService from './service';

/**
 * Sets the session
 * @param {*} user
 */
const setSession = user => {
    if (user) localStorage.setItem('user', JSON.stringify(user));
    else localStorage.removeItem('user');
};
/**
 * Login the user
 * @param {Object} action - dispatched actions
 */
function* login({ payload }) {
        const res = yield call(AuthService.login, payload);
        if (res.status === 200) {
            setSession(res.data);
            yield put(loginUserSuccess(res.data));
        } else {
            yield put(loginUserError(res));
            setSession(null);
        }
}

/**
 * Logout the user
 * @param {*} param0
 */
function* logout({ payload: { history } }) {
    try {
        setSession();
        yield call(() => {
            history.push('/account/login');
        });
    } catch (error) {}
}

/**
 * Register the user
 */
function* register({ payload }) {
    const res = yield call(AuthService.registerUser, payload)
    if (res.status === 200) {
        setSession(res.data);
        yield put(registerUserSuccess(res.data))
    } else {
        yield put(registerUserError(res))
    }
}

/**
 * Update the user
 */
function* update({ payload }) {
    const res = yield call(AuthService.updateUser, payload)
    if (res.status === 200) {
        setSession(res.data);
        yield put(updateUserSuccess(res.data))
    } else {
        yield put(updateUserError(res))
    }
}

/**
 * forget password
 */
function* forgetPassword({ payload: { email } }) {
    const res = yield call(AuthService.forgotPassword, email);
    if (res.status === 200) {
        yield put(forgetPasswordSuccess(res.data));
    } else {
        yield put(forgetPasswordError(res));
    }
}

function* saveBankAttributesSaga({ payload }) {
    const res = yield call(AuthService.updateBankAttributes, payload)

    if (res.status === 200) {
        yield put(saveBankAttributesSuccess(res.data));
    } else {
        yield put(saveBankAttributesError(res))
    }
}

function* saveBusinessAttributesSaga({ payload }) {
    const res = yield call(AuthService.updateBusinessAttributes, payload)

    if (res.status === 200) {
        yield put(saveBusinessAttributesSuccess({ ...res.data, silent: payload.silent, first_access: payload.first_access }))
    } else {
        yield put(saveBusinessAttributesError(res))
    }
}

function* sendDocumentsSaga({ payload }) {
    const { user } = yield select(store => store.Auth)
    const res = yield call(AuthService.sendDocument, payload, user)

    if (res.status === 200) {
        yield put(sendDocumentsSuccess(res.data))
    } else {
        yield put(sendDocumentsError(res))
    }
}

function* updateCompanyTagsSaga({ payload }) {
    const res = yield call(AuthService.updateCompanyTags, payload)

    if (res.status === 200) {
        yield put(updateUserFields({ company_tags: res.data }))
        yield put(updateCompanyTagsSuccess())
    } else {
        yield put(updateCompanyTagsError(res))
    }
}

function* changePasswordSaga({ payload }) {
    const res = yield call(AuthService.changePassword, payload.password)

    if (res.status === 200) {
        yield put(changePasswordSucces())
    } else {
        yield put(changePasswordError(res))
    }
}

function* saveMercadoPagoTokenSaga({ payload }) {
    const res = yield call(AuthService.saveMercadoPagoToken, payload);

    if(res.status === 200) {
        yield put(saveMercadoPagoTokenSuccess());
    }
    else {
        yield put(saveMercadoPagoTokenError(res));
    }
}

function* savePagSeguroCredentialsSaga({ payload }) {
    const { email, token } = payload;

    const res = yield call(AuthService.savePagSeguroCredentials, { email, token });
    if(res.status === 200) {
        yield put(savePagSeguroCredentialsSuccess());
    }
    else {
        yield put(savePagSeguroCredentialsError(res));
    }
}

function* saveGetnetCredentialsSaga({ payload }) {
    const res = yield call(AuthService.saveGetnetCredentials, payload);
    if (res.status === 200) {
        yield put(saveGetnetCredentialsSuccess());
    } else {
        yield put(saveGetnetCredentialsError(res));
    }
}

function* createPixKeySaga() {
    const res = yield call(AuthService.createPixKey);
    if (res.status === 200) {
        yield put(updateUserFields({ juno_pix_key: res.key }))
        yield put(createPixKeySuccess());
    } else {
        yield put(createPixKeyError(res));
    }
}


export function* watchLoginUser() {
    yield takeEvery(LOGIN_USER, login);
}

export function* watchLogoutUser() {
    yield takeEvery(LOGOUT_USER, logout);
}

export function* watchRegisterUser() {
    yield takeEvery(REGISTER_USER, register);
}

export function* watchUpdateUser() {
    yield takeEvery(UPDATE_USER, update);
}

export function* watchForgetPassword() {
    yield takeEvery(FORGET_PASSWORD, forgetPassword);
}

export function* watchSaveBankAttributes() {
    yield takeEvery(SAVE_BANK_ATTRIBUTES, saveBankAttributesSaga)
}

export function* watchSaveBusinessAttributes() {
    yield takeEvery(SAVE_BUSINESS_ATTRIBUTES, saveBusinessAttributesSaga)
}

export function* watchSendDocuments() {
    yield takeEvery(SEND_DOCUMENTS, sendDocumentsSaga)
}

export function* watchUpdateCompanyTags() {
    yield takeEvery(UPDATE_COMPANY_TAGS, updateCompanyTagsSaga)
}

export function* watchChangePassword() {
    yield takeEvery(CHANGE_PASSWORD, changePasswordSaga)
}

export function* watchSaveMercadoPagoToken() {
    yield takeEvery(SAVE_MERCADO_PAGO_TOKEN, saveMercadoPagoTokenSaga)
}

export function* watchSavePagSeguroCredentials() {
    yield takeEvery(SAVE_PAG_SEGURO_CREDENTIALS, savePagSeguroCredentialsSaga)
}

export function* watchSaveGetnetCredentials() {
    yield takeEvery(SAVE_GETNET_CREDENTIALS, saveGetnetCredentialsSaga)
}

export function* watchCreatePixKey() {
    yield takeEvery(CREATE_PIX_KEY, createPixKeySaga)
}


function* authSaga() {
    yield all([
        fork(watchLoginUser), 
        fork(watchLogoutUser), 
        fork(watchRegisterUser), 
        fork(watchUpdateUser), 
        fork(watchForgetPassword),
        fork(watchSaveBusinessAttributes),
        fork(watchSaveBankAttributes),
        fork(watchSendDocuments),
        fork(watchUpdateCompanyTags),
        fork(watchChangePassword),
        fork(watchSaveMercadoPagoToken),
        fork(watchSavePagSeguroCredentials),
        fork(watchSaveGetnetCredentials),
        fork(watchCreatePixKey)
    ]);
}

export default authSaga;
